import { useTranslation } from 'react-i18next';

export default function ProcessSteps() {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('servicesPage.processStep1'),
      description: t('servicesPage.processStep1Desc'),
      icon: 'ri-search-eye-line',
      color: 'from-[#FF6B6B] to-[#FF8E53]'
    },
    {
      number: '02',
      title: t('servicesPage.processStep2'),
      description: t('servicesPage.processStep2Desc'),
      icon: 'ri-file-list-3-line',
      color: 'from-[#4ECDC4] to-[#44A08D]'
    },
    {
      number: '03',
      title: t('servicesPage.processStep3'),
      description: t('servicesPage.processStep3Desc'),
      icon: 'ri-tools-line',
      color: 'from-[#A855F7] to-[#9333EA]'
    },
    {
      number: '04',
      title: t('servicesPage.processStep4'),
      description: t('servicesPage.processStep4Desc'),
      icon: 'ri-checkbox-circle-line',
      color: 'from-[#3B82F6] to-[#1D4ED8]'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#4ECDC4]/10 rounded-full text-[#4ECDC4] text-sm font-semibold mb-4">
            <i className="ri-flow-chart"></i>
            {t('servicesPage.processBadge')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t('servicesPage.processTitle')}
            <span className="bg-gradient-to-r from-[#4ECDC4] to-[#44A08D] bg-clip-text text-transparent"> {t('servicesPage.processTitleHighlight')}</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('servicesPage.processSubtitle')}
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#FF6B6B] via-[#4ECDC4] to-[#3B82F6] transform -translate-y-1/2 rounded-full"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100 relative z-10">
                  {/* Number Badge */}
                  <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center mb-6 mx-auto shadow-lg`}>
                    <span className="text-white text-2xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {step.number}
                    </span>
                  </div>

                  {/* Icon */}
                  <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-gray-600 text-xl`}></i>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 text-center mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-center text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Arrow for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                    <div className="w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[#FF6B6B] text-xl"></i>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
